import { render } from "./draft.vue?vue&type=template&id=17ffa695"
import script from "./draft.js?vue&type=script&lang=js"
export * from "./draft.js?vue&type=script&lang=js"

import "./draft.vue?vue&type=style&index=0&id=17ffa695&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__